export default __webpack_public_path__ + "static/media/pw-template-add.1854e884.jpg";